import { createContext, useContext, useEffect } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useLocation } from "react-router";
import { getCurrentUserApi } from "../DAL";
import { getFromStorage } from "../utils";
import { QUERY_CONSTANTS } from "../constants";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  useLocation();
  const queryClient = useQueryClient();
  const token = getFromStorage("accessToken");

  const {
    data: currentUser,
    isLoading,
  } = useQuery({
    queryKey: [QUERY_CONSTANTS.CURRENT_USER],
    queryFn: async () => {
      const response = await getCurrentUserApi();
      return response.data.user;
    },
    enabled: !!token,
  });

  useEffect(() => {
    if (!token) {
      queryClient.clear();
    }
  }, [token, queryClient]);

  const clearAuth = () => {
    sessionStorage.clear();
  };

  return (
    <AuthContext.Provider value={{ currentUser, isLoading, clearAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
